import React, { useEffect, useState } from "react";
import { Tab } from "semantic-ui-react";
import ResearchFoldersList from "../components/ResearchFoldersList";
import CentersList from "../components/CentersList";
import { getLabAppointmentsByCenterGroup } from "services/labAppointment";
import { useDispatch } from "react-redux";
import moment from "moment";

const DATE_FORMAT = "YYYY-MM-DD";

const TabPaneCT = ({ setOpenFolderManager, ctGroup }) => {
	const dispatch = useDispatch();
	const [initialLoading, setInitialLoading] = useState(true);
	const [list, setList] = useState([]);
	const [pages, setPages] = useState(0);
	const [totalCount, setTotalCount] = useState(0);
	const [centers, setCenters] = useState([]);

	useEffect(() => {
		fetchCT();
	}, [ctGroup]);

	const fetchCT = async (filters) => {
		setInitialLoading(true);
		const response = await dispatch(
			getLabAppointmentsByCenterGroup(filters?.date || moment().format(DATE_FORMAT), ctGroup, filters?.showDone || false, filters?.page || 1)
		);
		if (response?.payload?.data) {
			setList(response.payload.data.results);
			setPages(response.payload.data.pagination?.pages || 0);
			setTotalCount(response.payload.data.pagination?.total || 0);
			setCenters(response.payload.data.centers || []);
		}
		setInitialLoading(false);
	};

	const goToFolderManager = (folderId) => {
		if (folderId) {
			dispatch({ type: "SET_FOCUSED_FOLDERS", payload: [folderId] });
			setOpenFolderManager(true);
		}
	};
	return (
		<Tab.Pane attached={false}>
			<CentersList centers={centers} setCenters={setCenters} />
			<ResearchFoldersList
				list={list}
				goToFolderManager={goToFolderManager}
				loading={initialLoading}
				refreshList={fetchCT}
				listTotalCount={totalCount}
				pages={pages}
			/>
		</Tab.Pane>
	);
};
export default TabPaneCT;
